import { Reveal } from "@/lib/motion";
import { RESULTS } from "@/data/site";

export const Results = () => (
  <section data-testid="results" className="section-pad bg-[#F5F5F5]">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.25em] text-[#999999] mb-6 font-mono">Results snapshot</p>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] max-w-3xl text-[#111111]">
          Real numbers. Not vanity metrics.
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t border-l border-[#E0E0E0]">
        {RESULTS.map((r, i) => (
          <Reveal key={i} delay={i * 0.08}>
            <div className="p-8 md:p-10 border-r border-b border-[#E0E0E0] h-full bg-[#F5F5F5]">
              <p className="font-serif text-6xl md:text-7xl leading-none text-[#111111]">{r.stat}</p>
              <p className="mt-6 text-[#666666] leading-relaxed">{r.label}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
